'use strict';
module.exports = require('../../full/url');
